/* eslint-disable react/prop-types */
import { faCreditCard } from '@fortawesome/free-regular-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import classNames from 'classnames';
import React from 'react';
import { Form } from 'react-bootstrap';

function PayRadioInput({
  options,
  data,
  setData,
  icon,
  disable = false,
  className,
  image
}) {
  const handleRadioClick = option => {
    setData(option);
  };

  return (
    <>
      {options?.map((option, index) => (
        <Form.Group key={index}>
          <div
            className={classNames(
              'd-flex align-items-center mb-3 cursor-pointer',
              className,
              { 'item-disable': disable }
            )}
            onClick={!disable ? () => handleRadioClick(option.value) : null}
          >
            <div className="card-icon">
              {image ? (
                <img className="img-fluid" src={image} alt="" />
              ) : (
                <FontAwesomeIcon
                  icon={icon || faCreditCard}
                  className="text-white"
                  size="lg"
                />
              )}
            </div>

            <div className="flex-1 cursor-pointer">
              <p className="fs-0 mb-0 fw-semi-bold text-1000">{option.title}</p>
              {option.subText1 && (
                <p className="mb-0 fs--1">{option.subText1}</p>
              )}
              {option.subText2 && (
                <p className="mb-0 fs--1">{option.subText2}</p>
              )}
            </div>

            <Form.Check
              type="radio"
              name="radio_item"
              checked={!disable && data === option.value}
              readOnly
            />
          </div>
        </Form.Group>
      ))}
    </>
  );
}

export default PayRadioInput;
